import SectionOrgGroups from './SectionOrgGroups'

export default SectionOrgGroups
